/*
 * @Author: your name
 * @Date: 2020-11-24 09:33:11
 * @LastEditTime: 2020-12-14 18:07:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/mudules/localStorage.js
 */

import {
  GET_TAB_PASS_CODE,
  SET_TAB_PASS_CODE
} from './mutations'

// initial state
const state = () => ({
  tabPassCode: localStorage.getItem('tabPassCode') || ''
})

// getters
const getters = {}

// actions
const actions = {

}

// mutations
const mutations = {
  [SET_TAB_PASS_CODE](state, tabPassCode) {
    state.tabPassCode = tabPassCode
    localStorage.setItem('tabPassCode', tabPassCode)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}